import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: 'default' | 'flat';
  tight?: boolean;
  interactive?: boolean;
}

export function Card({
  children,
  variant = 'default',
  tight,
  interactive,
  className,
  ...rest
}: CardProps): JSX.Element {
  const classes = [
    styles.card,
    variant === 'flat' && styles.flat,
    tight && styles.tight,
    interactive && styles.interactive,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
